import { useCurrentUser } from '@/services/auth';

/** Whether the user's active company is Trans Ova Genetics (TOG). */
export function useIsTogActive(): boolean {
  const { data: currentUser } = useCurrentUser();
  return (
    currentUser?.companies?.some(
      (company) => company.code === 'TOG' && company.isActive,
    ) ?? false
  );
}
